<div class="mlc-dialog">

  <!-- Header -->
  <div class="mlc-header">
    <div class="mlc-title">
      <mat-icon class="mlc-title-icon">psychology</mat-icon>
      Manage Learning Concepts
    </div>
    <button mat-icon-button (click)="close()" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <!-- Add new concept -->
  <div class="mlc-add-row">
    <mat-form-field appearance="outline" class="mlc-add-field">
      <mat-label>New Concept Name</mat-label>
      <input matInput [formControl]="newConceptCtrl"
             (keyup.enter)="addConcept()"
             placeholder="e.g. Good Touch Bad Touch">
      <mat-error *ngIf="newConceptCtrl.hasError('required')">Name is required</mat-error>
      <mat-error *ngIf="newConceptCtrl.hasError('minlength')">At least 2 characters</mat-error>
    </mat-form-field>
    <button mat-flat-button color="primary"
            (click)="addConcept()"
            [disabled]="isSaving"
            class="mlc-add-btn">
      <mat-icon>add</mat-icon> Add
    </button>
  </div>

  <mat-divider></mat-divider>

  <!-- Loading -->
  <div *ngIf="isLoading" class="mlc-loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && concepts.length === 0" class="mlc-empty">
    <mat-icon>info_outline</mat-icon>
    <span>No concepts yet. Add one above.</span>
  </div>

  <!-- Concept list -->
  <div class="mlc-list" *ngIf="!isLoading && concepts.length > 0">
    <div *ngFor="let item of concepts; let i = index" class="mlc-item">

      <!-- View mode -->
      <ng-container *ngIf="!item.editing">
        <span class="mlc-item-num">{{ i + 1 }}.</span>
        <span class="mlc-item-name">{{ item.value }}</span>
        <div class="mlc-item-actions">
          <button mat-icon-button color="primary"
                  (click)="startEdit(item)"
                  matTooltip="Edit">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn"
                  (click)="deleteConcept(item)"
                  matTooltip="Delete">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </ng-container>

      <!-- Edit mode -->
      <ng-container *ngIf="item.editing">
        <span class="mlc-item-num">{{ i + 1 }}.</span>
        <mat-form-field appearance="outline" class="mlc-edit-field">
          <input matInput [(ngModel)]="item.editValue"
                 (keyup.enter)="saveEdit(item)"
                 (keyup.escape)="cancelEdit(item)">
        </mat-form-field>
        <div class="mlc-item-actions">
          <button mat-icon-button color="primary"
                  (click)="saveEdit(item)"
                  [disabled]="isSaving"
                  matTooltip="Save">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button
                  (click)="cancelEdit(item)"
                  matTooltip="Cancel">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </ng-container>

    </div>
  </div>

  <!-- Footer -->
  <mat-divider></mat-divider>
  <div class="mlc-footer">
    <span class="mlc-count">{{ concepts.length }} concept(s) total</span>
    <button mat-stroked-button (click)="close()">Done</button>
  </div>

</div>

